"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportBulkAddMultipleApi = reportBulkAddMultipleApi;
exports.reportBulkAlertOffApi = reportBulkAlertOffApi;
exports.reportBulkAlertOnApi = reportBulkAlertOnApi;
exports.reportBulkApproveApi = reportBulkApproveApi;
exports.reportBulkDeleteApi = reportBulkDeleteApi;
exports.reportBulkGoLiveApi = reportBulkGoLiveApi;
exports.reportBulkLockApi = reportBulkLockApi;
exports.reportBulkPauseApi = reportBulkPauseApi;
exports.reportBulkPlayApi = reportBulkPlayApi;
exports.reportBulkSoftDeleteApi = reportBulkSoftDeleteApi;
exports.reportBulkSoftDeleteRestoreApi = reportBulkSoftDeleteRestoreApi;
exports.reportBulkSubmitApi = reportBulkSubmitApi;
exports.reportBulkUnlockApi = reportBulkUnlockApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * bulk site submit
 * @param payload
 * @returns api response
 * @description this function used to bulk site submit.
 */
function reportBulkSubmitApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkSubmit), params);
}

/**
 * bulk delete reports
 * @param payload
 * @returns api response
 * @description this function used to bulk delete multiple reports.
 */
function reportBulkDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkDeleted), params);
}

/**
 * go live reports
 * @param payload
 * @returns api response
 * @description this function used to go live reports.
 */
function reportBulkGoLiveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkGoLive), params);
}
/**
 * bulk site submit
 * @param payload
 * @returns api response
 * @description this function used to bulk site submit.
 */
function reportBulkAddMultipleApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.buildAdd), params);
}

/**
 * play reports
 * @param payload
 * @returns api response
 * @description this function used to play reports.
 */
function reportBulkPlayApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkPlay), params);
}

/**
 * pause reports
 * @param payload
 * @returns api response
 * @description this function used to pause reports.
 */
function reportBulkPauseApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkPause), params);
}

/**
 * alert on reports
 * @param payload
 * @returns api response
 * @description this function used to alert on reports.
 */
function reportBulkAlertOnApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkAlertOn), params);
}

/**
 * alert off reports
 * @param payload
 * @returns api response
 * @description this function used to alert off reports.
 */
function reportBulkAlertOffApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkAlertOff), params);
}

/**
 * lock reports
 * @param payload
 * @returns api response
 * @description this function used to lock reports.
 */
function reportBulkLockApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkLock), params);
}

/**
 * unlock reports
 * @param payload
 * @returns api response
 * @description this function used to unlock reports.
 */
function reportBulkUnlockApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkUnlock), params);
}
/**
 * approve reports
 * @param payload
 * @returns api response
 * @description this function used to approve reports.
 */
function reportBulkApproveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkApprove), params);
}
/**
 * bulk soft delete reports
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete reports.
 */
function reportBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkSoftDelete), params);
}
/**
 * bulk soft delete reports
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete reports.
 */
function reportBulkSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportBulk.bulkSoftDeleteRestore), params);
}